export var TipoExpresion3D;
(function (TipoExpresion3D) {
    TipoExpresion3D[TipoExpresion3D["PRIMITIVA"] = 0] = "PRIMITIVA";
    TipoExpresion3D[TipoExpresion3D["OPERACION"] = 1] = "OPERACION";
})(TipoExpresion3D || (TipoExpresion3D = {}));
